import { render, staticRenderFns } from "./FormImagen.vue?vue&type=template&id=085ee035&"
import script from "./FormImagen.vue?vue&type=script&lang=js&"
export * from "./FormImagen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports